import { useSearchParams } from 'next/navigation';
import { useIntl } from 'react-intl';

import { Button } from '@calm-web/design-system';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import Header from '@/components/PreSignupFlow/Components/OnboardingHeader';
import { useAnalytics } from '@/hooks/analytics';
import { validate } from '@/utils/ui/validator';

import Conversion from './Conversion';
import Features from './Features';
import Hero from './Hero';
import messages from './messages';
import StressRelaxSleep from './StressRelaxSleep';
import { OfferForText } from './styles';
import Testimonials from './Testimonials';

const SecondFreeTrial = () => {
	const searchParams = useSearchParams();
	const offerFor = validate('email', searchParams?.get('offerFor') as string)
		? (searchParams?.get('offerFor') as string)
		: undefined;

	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	const logClickCTA = () => {
		logEvent({
			eventName: 'Page : CTA_header : Clicked',
			eventProps: {
				type: 'button',
				copy: formatMessage(messages.sharedCta),
			},
		});
	};

	const intersectingContent = (
		<Button
			href="/signup-flow?source=second_free_trial_offer&focus=second_free_trial"
			backgroundColor="gradientCalmBrand"
			onPress={logClickCTA}
		>
			{formatMessage(messages.sharedCta)}
		</Button>
	);

	const landingContent = (
		<OfferForText>
			{formatMessage(messages.sharedSpecialOfferFor, {
				email: offerFor,
			})}
		</OfferForText>
	);

	return (
		<>
			<Header
				isSticky
				staticContent={offerFor ? landingContent : intersectingContent}
				intersectingContent={intersectingContent}
			/>
			<main role="main" id={MAIN_CONTENT_ID}>
				<Hero />
				<StressRelaxSleep />
				<Testimonials />
				<Features />
				<Conversion />
			</main>
		</>
	);
};

export default SecondFreeTrial;
